import { configureStore } from '@reduxjs/toolkit'
import { apiSlice } from './slices/api/apiSlice';
import authSliceReducer from './slices/authSlice';
import cartReducer from "./slices/cartSlice";
import orderReducer from "./slices/orderSlice";


const store = configureStore({
  reducer: {
    [apiSlice.reducerPath] : apiSlice.reducer,
    auth: authSliceReducer,
    cart: cartReducer,
    order: orderReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware()
  .concat(apiSlice.middleware),
  devTools: true, 
})

export default store